import { useQuery } from 'react-query';
import ListService from '../../../services/ListService';
import { LIST } from '../../constants/queryDefinition';

const listService = ListService.get();

export default function useSortMetaData() {
  const sortMetaData = useQuery(
    LIST.SORTMETADATA.KEY,
    listService.getSortMetaData,
    {
      placeholderData: { sortMethods: [] }
    }
  );

  return sortMetaData;
}
